import { useTranslation } from "react-i18next";

interface AudiencePreviewProps {
  count: number | null;
  officersOnly: boolean;
  loading: boolean;
}

export const AudiencePreview = ({ count, officersOnly, loading }: AudiencePreviewProps) => {
  const { t } = useTranslation();

  return (
    <div className="space-y-2">
      <div className="flex items-center gap-2 px-3 py-2 bg-indigo-50 border border-indigo-100 rounded-lg text-sm">
        <svg
          className="w-4 h-4 text-indigo-500 shrink-0"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z"
          />
        </svg>
        {loading ? (
          <span className="text-indigo-600">
            {t("feed.form.loading_audience")}
          </span>
        ) : count !== null ? (
          <span className="text-indigo-700 font-medium">
            {t("feed.form.audience_count", { count })}
          </span>
        ) : null}
      </div>

      {!loading && officersOnly && (
        <div className="flex items-start gap-2 px-3 py-2 bg-amber-50 border border-amber-300 rounded-lg text-sm">
          <svg
            className="w-4 h-4 text-amber-500 shrink-0 mt-0.5"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 9v2m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"
            />
          </svg>
          <span className="text-amber-700">
            {t("feed.form.officers_only_warning")}
          </span>
        </div>
      )}
    </div>
  );
};
